<template>
    <div class="footer">
        <div class="footerBg">Copyright © 2020 HOLIDAY MUSEUM Inc. All rights reserved. © 2020</div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
 components: {},
 props: {},
 data () {
 return {
 };
 },
 watch: {},
 computed: {},
 methods: {},
 mounted () {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue